import React, { createContext, useState, useEffect } from "react";

export const AppContext = createContext();

const initialUser = {
  email: null,
  username: null,
  isSuperuser: false,
  isAdmin: false,
  isVendedor: false,
  isLoggedIn: false,
};

export const AppProvider = ({ children }) => {
  const [sections, setSections] = useState([]);
  const [brands, setBrands] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [user, setUser] = useState(initialUser);

  const fetchSections = async () => {
    try {
      const response = await fetch("/categorias/secciones/");
      if (!response.ok) throw new Error();
      const data = await response.json();
      setSections(data);
    } catch {}
  };

  const fetchBrands = async () => {
    try {
      const response = await fetch("/categorias/marcas/");
      if (!response.ok) throw new Error();
      const data = await response.json();
      setBrands(data);
    } catch {}
  };

  useEffect(() => {
    fetchSections();
    fetchBrands();
    const storedCart = localStorage.getItem("cartItems");
    if (storedCart) setCartItems(JSON.parse(storedCart));

    const u = {
      email: localStorage.getItem("user_email"),
      username: localStorage.getItem("user_name"),
      isSuperuser: localStorage.getItem("is_superuser") === "true",
      isAdmin: localStorage.getItem("is_admin") === "true",
      isVendedor: localStorage.getItem("is_vendedor") === "true",
      isLoggedIn: localStorage.getItem("is_logged_in") === "true",
    };
    setUser((prev) => ({ ...prev, ...u }));
  }, []);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product, quantity) => {
    setCartItems((prev) => {
      const existing = prev.find((i) => i.id === product.id);
      if (existing) {
        return prev.map((i) =>
          i.id === product.id ? { ...i, quantity: i.quantity + quantity } : i
        );
      }
      return [...prev, { ...product, quantity }];
    });
  };

  const removeFromCart = (id) =>
    setCartItems((prev) => prev.filter((i) => i.id !== id));

  const clearCart = () => setCartItems([]);

  const refreshSections = async () => {
    await fetchSections();
  };

  const refreshBrands = async () => {
    await fetchBrands();
  };

  const loginUser = ({ email, username, isSuperuser, isAdmin, isVendedor }) => {
    const payload = {
      email: email || null,
      username: username || null,
      isSuperuser: !!isSuperuser,
      isAdmin: !!isAdmin,
      isVendedor: !!isVendedor,
      isLoggedIn: true,
    };

    setUser(payload);
    localStorage.setItem("user_email", payload.email ?? "");
    localStorage.setItem("user_name", payload.username ?? "");
    localStorage.setItem("is_superuser", String(payload.isSuperuser));
    localStorage.setItem("is_admin", String(payload.isAdmin));
    localStorage.setItem("is_vendedor", String(payload.isVendedor));
    localStorage.setItem("is_logged_in", "true");
  };

  const logoutUser = () => {
    setUser(initialUser);
    localStorage.removeItem("user_email");
    localStorage.removeItem("user_name");
    localStorage.removeItem("is_superuser");
    localStorage.removeItem("is_admin");
    localStorage.removeItem("is_vendedor");
    localStorage.removeItem("is_logged_in");
  };

  return (
    <AppContext.Provider
      value={{
        sections,
        setSections,
        brands,
        setBrands,
        refreshSections,
        refreshBrands,
        cartItems,
        setCartItems,
        addToCart,
        removeFromCart,
        clearCart,
        user,
        loginUser,
        logoutUser,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
